<template>
  <div v-loading='loading' class='my'>
    <div class='avatar-wrapper'>
      <img :src='avatarPath' alt='' class='avatar'>
      <div class='user-info'>
        <span class='user-name'>{{ name }}</span>
        <span class='member-type'>会员</span>
        <a href='javascript:;' class='check-my-info' @click='goRouter("/myinfo")'>点击查看个人资料</a>
      </div>
    </div>
    <div class='nav-wrapper'>
      <!-- 导航 普通会员 -->
      <p class='title'>班级订单</p>
      <ul class='nav-bar'>
        <li @click='goRouter("/myorder/group_all")'>
          <img src='../assets/imgs/my_info.png' alt='' class='icon-bg'>
          <span>全部订单</span>
        </li>
        <li @click='goRouter("/myorder/group_ispay")'>
          <img src='../assets/imgs/my_ispay.png' alt='' class='icon-bg'>
          <span>已付款订单</span>
        </li>
        <li @click='goRouter("/myorder/group_isrefund")'>
          <img src='../assets/imgs/my_isrefund.png' alt='' class='icon-bg'>
          <span>退款订单</span>
        </li>
      </ul>
      <p class='title'>个人订单</p>
      <ul class='nav-bar'>
        <li @click='goRouter("/myorder/person_all")'>
          <img src='../assets/imgs/my_info.png' alt='' class='icon-bg'>
          <span>全部订单</span>
        </li>
      </ul>
      <a href='javascript:;' class='btn-logout' @click='logout'>退出账号</a>
    </div>

    <!-- 登录 -->
    <v-login v-if='showLogin' @success='loginSuccess' @register='registerHandler' @resetPwd='resetPwdHanler'/>
    <!-- 注册 -->
    <v-register v-if='showRegister' @registerSuccess='registerSuccess'/>
    <!-- 重置密码 -->
    <v-reset-pwd v-if='showResetPwd' @resetPwdSuccess='resetPwdSuccess' @cancelResetPwd='cancelResetPwd' />
    <!-- 绑定手机 -->
    <v-bind-phone v-if='showBindPhone' :openid='openid' @bindPhoneSuccess='bindPhoneSuccess'/>
  </div>
</template>
<script>
import Login from '@/components/Login'
import Register from '@/components/Register'
import ResetPwd from '@/components/ResetPwd'
import BindPhone from '@/components/BindPhone'

import { USER_INFO, ADMIN_INFO, LOGOUT_MEMBER, LOGOUT_ADMIN } from '@/api'

export default {
  components: {
    VLogin: Login,
    VRegister: Register,
    VResetPwd: ResetPwd,
    VBindPhone: BindPhone
  },
  data() {
    return {
      showLogin: false,
      loading: false,
      showRegister: false,
      showResetPwd: false,
      showBindPhone: false,
      openid: null
    }
  },
  computed: {
    name() {
      return this.$store.state.userInfo.name || this.$store.state.userInfo.username
    },

    memberType() {
      return this.$store.state.memberType
    },

    memberText() {
      return this.$store.state.memberType === 'MEMBER' ? '会员' : '管理员'
    },

    avatarPath() {
      return this.$store.state.userInfo.avatar_path
    }
  },
  created() {
    // this.getToken()
    
    this.setActiveBar('MY')
    this.getUserInfo()
        
  },
  methods: {
    // 显示重置密码
    resetPwdHanler() {
      this.showLogin = false
      this.showResetPwd = true
    },

    // 取消重置密码
    cancelResetPwd() {
      this.showResetPwd = false
      this.showLogin = true
    },

    // 重置密码成功
    resetPwdSuccess() {
      this.showResetPwd = false
      this.showLogin = true
    },

    // 注册成功
    registerSuccess() {
      this.showRegister = false
      this.showLogin = false
      this.getUserInfo()
    },

    // 绑定手机号成功
    bindPhoneSuccess() {
      this.showLogin = false
      this.showBindPhone = false
      this.getUserInfo()
    },

    // 显示注册
    registerHandler() {
      this.showLogin = false
      this.showRegister = true
    },

    // 登录成功
    loginSuccess() {
      this.showLogin = false
      this.getUserInfo()
    },

    // 获取用户信息
    getUserInfo() {
      let type = this.$store.state.memberType
      if (type === 'MEMBER') this.getMemberInfo()
      else this.getAdminInfo()
    },

    // 用户信息-普通会员
    getMemberInfo() {
      this.loading = true
      USER_INFO().then(res=>{
        this.loading = false
        if (res.data.code === 0 ) {
          this.storeUserInfo(res.data.data)
        } else if (res.data.code === 40001 || res.data.code === 20005) {
          this.removeToken()
          // 检测登录
          this.checkUserLogin()
        }
      })
    },

    // 用户信息-管理员
    getAdminInfo() {
      this.loading = true
      ADMIN_INFO().then(res=>{
        this.loading = false
        if (res.data.code === 0 ) {
          this.storeUserInfo(res.data.data)
        } else if (res.data.code === 40001 || res.data.code === 20005) {
          this.showLogin = true
        }
      })

    },

    // 存储用户信息
    storeUserInfo(info) {
      this.$store.commit('setUserInfo',info)
    },
        
    // 退出
    logout() {
      let type = this.$store.state.memberType
      if (type === 'MEMBER') this.logoutMember()
      else this.logoutAdmin()
    },

    // 退出-会员
    logoutMember() {
      this.loading = true
      LOGOUT_MEMBER().then(res=>{
        this.loading = false
        if (res.data.code === 0) {
          this.$notify('退出成功')
        } 
        this.removeToken()
        this.removeCookie('token')
        this.removeCookie('openid')
        this.removeCookie('code')
        this.goRouter('/home')
        setTimeout(() => {
          localStorage.removeItem('HAS_SHOW_NOTICE')
        }, 1000)
      })
    },

    // 清除cookie
    removeCookie(cname) {
      this.setCookie(cname,'',-1)
    },

    //设置cookie
    setCookie(cname, cvalue, exdays) {
      var d = new Date()
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
      var expires = 'expires=' + d.toUTCString()
      document.cookie = cname + '=' + cvalue + '; ' + expires
    },

    // 退出-管理员
    logoutAdmin() {
      this.loading = true
      LOGOUT_ADMIN().then(res=>{
        this.loading = false
        if (res.data.code === 0) {
          this.removeToken()
          this.goRouter('/home')
        } else {
          this.notify(res.data.msg,'error')
        }
      })
    },

    // 检测登录
    checkUserLogin() {
      // 本地所存储的token
      let hasLocalToken = this.checkLogin()
      
      // cookie中的token(微信扫码登录重定向后会携带)
      let cookieToken = this.getCookieVal('token')
      let openid = this.getCookieVal('openid')
      let code = this.getCookieVal('code') - 0
      this.openid = openid
      if (!cookieToken && !hasLocalToken) {
        this.showLogin = true
      }
      if (!hasLocalToken && code === 20009) {
        this.showLogin = false
        this.showBindPhone = true
      }
      if (!hasLocalToken && code === 0 && cookieToken) {
        this.storeToken(cookieToken)
        this.loading = true
        setTimeout(()=>{
          this.getUserInfo()
        },100)
      }

    },

    // 获取token
    getToken() {
      let cookieToken = this.getCookieVal('token')
      let openid = this.getCookieVal('openid')
      let code = this.getCookieVal('code') - 0
      let localToken = localStorage.getItem('WAITU_TOKEN')
      this.openid = openid
      if (code === 20009 && !localToken) {
        // 绑手机
        this.showLogin = false
        this.showBindPhone = true
      } else if (code === 1) {
        this.storeToken(cookieToken)
      }
    },
    
    // 获取cookie
    getCookieVal(name) {
      var nameEQ = name + '='
      var ca = document.cookie.split(';')
      for (var i = 0;i < ca.length;i++) {
        var c = ca[i]
        while (c.charAt(0) == ' ') c = c.substring(1,c.length)
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length)
      }
      return null
    }
        
  },
}
</script>

<style lang="less" scoped>
@import "../assets/css/mixin.less";
.my {
  width: 1200px;
  box-sizing: border-box;
  padding: 40px 180px;
  display: flex;
  flex-direction: row;

  .avatar-wrapper {
    height: 180px;
    width: 300px;
    position: relative;

    .avatar {
      width: 130px;
      height: 130px;
      border-radius: 50%;
    }
    .user-info {
      height: 40px;
      line-height: 40px;
      display: flex;
      flex-direction: column;
      
      .user-name {
        font-size: 18px;
        font-weight: 500;
        display: inline-block;
        width: 130px;
        text-align: center;
      }

      .member-type {
        display: inline-block;
        width: 60px;
        height: 28px;
        font-size: 14px;
        background: #00c36b;
        color: #fff;
        text-align: center;
        border-radius: 14px;
        line-height: 28px;
        position: absolute;  
        top: 139px;
        left: 145px;
      }

      .check-my-info {
        font-size: 14px;
        color: #3383b5;
        display: inline-block;
        width: 130px;
        text-align: center;
      }
    }
  }

  .nav-wrapper {
    .title {
      font-size: 20px;
      font-weight: 500;
      color: #333;
      padding-bottom: 26px;
    }
    .nav-bar {
      width: 500px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 80px;  
      li {
        position: relative;
        width: 85px;
        height: 130px;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
  
        .icon-bg {
          display: inline-block;
          width: 70px;
          height: 88px;
        }
  
        span {
          font-size: 16px;
          color: #000;
        }
      }
    }
  }

  .btn-logout {
    display: block;
    width: 250px;
    height: 38px;
    line-height: 38px;
    background: @blue-d;
    color: #fff;
    font-size: 20px;
    text-align: center;
    margin: 150px auto 0;
    border-radius: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/My.vue